import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import React, { useState } from 'react'
import ControlMeasureLabeledIconWithModal from './ControlMeasureLabeledIconWithModal';
import Colors from '../../colors';
import { Box } from '@mui/material';
import AddCustom from './AddCustom';

const detailsStyles = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(33%, 1fr))',
    marginBottom: '5px'
}

const containerStyles = {
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)',
    border: `1px solid ${Colors.green}`,
}

const msgStyles = {
    color: Colors.darkGray,
    fontSize: '18px',
    fontWeight: '600',
    margin: '0 auto',
}

function ControlMeasuresAccordion({
    controlMeasuresList, setControlMeasuresList,
    selectedControlMeasures, setSelectedControlMeasures, isEditable }) {

    const [expanded, setExpanded] = useState(false);

    const setSelectedControlMeasureCallback = (label) => {
        if (selectedControlMeasures.includes(label)) {
            setSelectedControlMeasures(selectedControlMeasures.filter(s => s !== label))
        } else {
            setSelectedControlMeasures([...selectedControlMeasures, label])
        }
    }

    const handleExpansion = (event, isExpanded) => {
        if (isEditable) {
            setExpanded(isExpanded);
        }
    };

    const addNewCustomHandler = (text) => {
        setControlMeasuresList([...controlMeasuresList, text])
        setSelectedControlMeasures([...selectedControlMeasures, text])
    };

    return (
        <>
            <Accordion
                expanded={expanded}
                onChange={handleExpansion}
                sx={containerStyles} >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    {selectedControlMeasures.length > 0 &&
                        <span style={msgStyles}>{`(${selectedControlMeasures.length}) control measures in place.`}</span>}
                    {selectedControlMeasures.length === 0 &&
                        <span style={msgStyles}>No control measures in place.</span>}
                </AccordionSummary>

                <AccordionDetails style={detailsStyles}>
                    {controlMeasuresList.map((controlMeasure) => (
                        <ControlMeasureLabeledIconWithModal
                            name={controlMeasure}
                            key={controlMeasure}
                            selectedControlMeasures={selectedControlMeasures}
                            setSelectedControlMeasureCallback={() => setSelectedControlMeasureCallback(controlMeasure)}
                            isEditable={isEditable} />
                    ))}
                    {isEditable && <AddCustom
                        modalLabel={'Add a new custom Control Measure to this form?'}
                        inputLabel={'Control Measure'}
                        dataCallback={addNewCustomHandler} />}
                </AccordionDetails>
            </Accordion>
            {!expanded && selectedControlMeasures.length > 0 && (
                <Box
                    sx={[detailsStyles, containerStyles]} >
                    {selectedControlMeasures.sort().map((controlMeasure) => (
                        <ControlMeasureLabeledIconWithModal
                            name={controlMeasure}
                            key={controlMeasure}
                            selectedControlMeasures={selectedControlMeasures}
                            setSelectedControlMeasureCallback={() => setSelectedControlMeasureCallback(controlMeasure)}
                            isEditable={isEditable} />))}
                </Box>
            )}
        </>
    )
}

export default ControlMeasuresAccordion;